exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/bootstrap/css/bootstrap.min.css"), "");
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);", ""]);
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/fonts/fontawesome-all.min.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/fonts/font-awesome.min.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./assets/fonts/fontawesome5-overrides.min.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c6c53c4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 42
// module chunks = 0